import * as React from 'react';
import type { SearchProps } from '@helpcenter/result-base';
import { KbSnippet } from 'view/common/result-kb-snippets';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { isThirdPartyArticle } from '@atlassian/help-center-common-util/is-external-resource';
import type { PortalInfo, SourceType } from 'rest/search/kbs/types';
export interface Props extends SearchProps {
	title: string;
	id: string;
	articleUrl?: string;
	articleSnippet: string;
	isSmartSnippet: boolean;
	pageVersion: number;
	score: number;
	sourceType?: SourceType;
	openNewTab?: boolean;
	isSuggestion?: boolean;
	elevated?: boolean;
	portalId?: string;
	portalName?: string;
	linkedPortals?: PortalInfo[];
}

export const parseBodyText = (text: string) =>
	// eslint-disable-next-line no-useless-escape
	text.replace(/\@\@\@hl\@\@\@/g, '<strong>').replace(/\@\@\@endhl\@\@\@/g, '</strong>');

const SearchResultKb: React.FC<Props> = ({
	title,
	portalName,
	portalId,
	id,
	articleUrl,
	articleSnippet,
	isSmartSnippet,
	pageVersion,
	score,
	linkedPortals,
	openNewTab,
	sourceType,
	...props
}) => {
	const articleId = id;
	const snippet = articleSnippet ? parseBodyText(articleSnippet) : '';

	const getArticleUrl = () => {
		if (isThirdPartyArticle(sourceType)) {
			return articleUrl || '';
		}

		if (portalId) {
			return `/portal/${portalId}/article/${articleId}`;
		}

		// If portalId doesnt exist in store, ie for global search, use the portalId for first linked portal
		if (Array.isArray(linkedPortals) && linkedPortals.length > 0) {
			return `/portal/${linkedPortals[0].portalId}/article/${articleId}`;
		}
		return `/article/${articleId}`;
	};

	return (
		<AnalyticsContext
			data={{
				attributes: {
					pageVersion,
					score,
					isSmartSnippet,
					articleId,
					portalId,
					sourceType,
					snippetsLength: snippet.length,
				},
			}}
		>
			<KbSnippet
				actionSubjectId="smartSuggestion"
				titleHtml={parseBodyText(title)}
				to={getArticleUrl()}
				openNewTab={openNewTab}
				snippet={snippet}
				portalName={portalName}
				sourceType={sourceType}
				{...props}
			/>
		</AnalyticsContext>
	);
};

export default SearchResultKb;
